import React, {Component} from 'react';
import styles from './ProfilePersonalInfo.module.css';
import {
  Paper,
  Toolbar,
  IconButton,
  Typography,
  withStyles,
} from '@material-ui/core';
import ChevronBackIcon from '../svgs/ChevronBackIcon';
import TextInput from '../TextInput';
import RadioForm from '../RadioForm';
import {PERSONAL_INFO_PROPS} from '../../../../shared/constants/RadioProps';
import {userProfile} from '../../../../shared/models/UserProfile';
import {withRouter} from 'react-router-dom';
import {rwbApi} from '../../../../shared/apis/api';
import {
  getRadioIndexForValue,
  isNullOrEmpty,
  isPhoneNumber,
  debounce,
  validURL,
} from '../../../../shared/utils/Helpers';
import {COUNTRY_OPTIONS} from '../../../../shared/constants/Countries';
import Loading from '../Loading';
import CountryModal from './CountryModal';
import AddressesList from './AddressesList';
import ScrollableListModal from './ScrollableListModal';
import {logUpdatePersonalInformation} from '../../../../shared/models/Analytics';
import {
  melissaLookup,
  melissaVerify,
} from '../../../../shared/utils/MelissaHelper';
import {projectConfig} from '../../../../shared/project-info/projectConfig';
import {
  addressFieldDisplay,
  addressFieldsConfig,
} from '../../../../shared/utils/configFormatter';
import ParentModal from '../ParentModal.react';

const {gender_radio_props, address_type_radio_props} = PERSONAL_INFO_PROPS;
const DEBOUNCE_MS = 500;

const useStyles = {
  root: {
    flexGrow: 1,
  },
  menuButton: {
    color: 'var(--white)',
  },
  title: {
    color: 'var(--white)',
    textTransform: 'capitalize',
    fontFamily: 'OpenSans-Bold',
    textAlign: 'center',
    // title should always center, regardless of length of siblings
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  toolbar: {
    position: 'relative',
    justifyContent: 'space-between',
    backgroundColor: 'var(--primary)',
  },
  button: {
    color: 'white',
    textTransform: 'capitalize',
  },
  save: {
    color: 'var(--white)',
    textTransform: 'capitalize',
    fontWeight: 'bold',
  },
};

class ProfilePersonalInfo extends Component {
  constructor(props) {
    super(props);

    const userData = userProfile.getUserProfile();
    const {
      first_name,
      last_name,
      email,
      phone,
      gender,
      gender_description,
    } = userData;
    let location = userData?.location || {};

    let {
      country = null,
      address = null,
      address_2 = null,
      address_state = null,
      city = null,
      zip = null,
    } = location;

    this.state = {
      needsToSave: false,
      showCountryModal: false,
      countrySlug: 'US',
      first_name,
      last_name,
      email,
      manual_address_entry: false,
      country,
      address,
      apartment: address_2,
      showApartmentModal: false,
      apartmentList: [],
      city,
      address_state,
      zip,
      phone,
      gender,
      fullAddress: '',
      addressSuggestions: [],
      email_error: '',
      phone_error: '',
      gender_error: '',
      isLoading: false,
      fullAddressInternational: '',
      stateDropdownVisible: false,
      gender_description,
      gender_description_error: '',
    };

    // If includePersonalInfo is true, show the various address fields.
    // Based on the whether registerProfileSteps has a PersonalInfo screen.
    this.includePersonalInfo = projectConfig.registerProfileSteps.some(
      (obj) => obj.screen === 'PersonalInfo',
    );
    // this.includePersonalInfo = true;

    // We compare it to this instead of the projectConfig.primaryCountry because the
    // primary country is in the form of a two-letter country code
    if (location?.country === 'United States') {
      this.state.address_type = 'domestic';
    } else {
      this.state.address_type = 'international';
    }
  }

  clearErrorWarnings() {
    this.setState({
      address_error: '',
      phone_error: '',
      gender_error: '',
    });
  }

  verifyAddress(complete_callback) {
    const {
      address,
      apartment,
      city,
      address_state,
      zip,
      address_type,
      fullAddressInternational,
    } = this.state;
    var country = this.state.country;
    if (!country) {
      this.setState({country_error: 'Please select a country'});
    } else {
      this.setState({country_error: undefined});
    }
    country =
      address_type === 'domestic' ? 'United States' : this.state.country;
    const addressWithApartment = `${fullAddressInternational} ${apartment}`;
    if (!isNullOrEmpty(addressWithApartment) && country.length) {
      melissaVerify(country, addressWithApartment, complete_callback).then(
        (result) => {
          try {
            this.setState({
              address: result.address_street,
              city: result.city,
              address_state: result.address_state,
              zip: result.zip,
              address_not_verified: result.address_not_verified,
              error_string: result.error_string,
            });
          } catch (e) {
            // This can happen if the user taps a control that results in a verification check
            // before all the address information is set
            console.warn(e);
          }
        },
      );
    }
  }

  savePressed() {
    if (
      this.state.address_type === 'international' &&
      !this.state.manual_address_entry &&
      projectConfig.useMelissaVerify
    ) {
      this.verifyAddress(() => {
        this.doSave();
      });
    } else {
      this.doSave();
    }
  }
  doSave() {
    const {
      first_name,
      last_name,
      email,
      address_type,
      country,
      address,
      apartment,
      city,
      address_state,
      zip,
      phone,
      gender,
      address_not_verified,
      gender_description,
    } = this.state;
    var {manual_address_entry} = this.state;
    logUpdatePersonalInformation();
    // Do validity checking on phone number with all formatting stripped out
    // (555) 555-1212 -> 5555551212
    let strippedPhone;
    if (phone) {
      strippedPhone = phone.replace(/\D/g, ``);
    }
    this.clearErrorWarnings();

    let field_is_required_string = 'THIS FIELD IS REQUIRED';
    const zipTest = /^\d\d\d\d\d$|^\d\d\d\d\d-\d\d\d\d$/;
    let hasError = false;

    if (isNullOrEmpty(email)) {
      this.setState({email_error: field_is_required_string});
      hasError = true;
    }

    if (this.includePersonalInfo && !projectConfig.useMelissaPostalCode) {
      if (isNullOrEmpty(address_type)) {
        hasError = true;
        this.setState({address_error: field_is_required_string});
      }
      // country can be ignored when the address_type is not international
      if (isNullOrEmpty(address)) {
        this.setState({address_error: field_is_required_string});
        hasError = true;
      }
      if (isNullOrEmpty(city)) {
        this.setState({city_error: field_is_required_string});
        hasError = true;
      }
      if (isNullOrEmpty(address_state)) {
        this.setState({state_error: field_is_required_string});
        hasError = true;
      }
      if (
        projectConfig.allowsOtherCountries &&
        address_type === 'international' &&
        !country?.length
      ) {
        hasError = true;
      }
      if (
        !manual_address_entry &&
        address_type === 'international' &&
        address_not_verified
      ) {
        hasError = true;
      }
    } else if (this.includePersonalInfo && projectConfig.useMelissaPostalCode) {
      if (isNullOrEmpty(zip)) {
        this.setState({zip_error: field_is_required_string});
        hasError = true;
      }
    }
    // Optional field despite the "optional" text being removed
    if (isNullOrEmpty(phone) && projectConfig.phoneRequired) {
      if (!isPhoneNumber(strippedPhone)) {
        this.setState({phone_error: 'PLEASE ENTER ONLY NUMBERS'});
        hasError = true;
      }
      if (strippedPhone.length !== 10) {
        this.setState({phone_error: 'PLEASE ENTER A 10-DIGIT PHONE NUMBER'});
        hasError = true;
      }
    }
    if (!gender && projectConfig.genderRequested) {
      this.setState({gender_error: 'PLEASE SELECT AN OPTION'});
      hasError = true;
    }
    if (gender == 'Custom' && !gender_description) {
      this.setState({
        gender_description_error:
          'IF CUSTOM GENDER IS SELECTED, THIS CANNOT BE BLANK',
      });
      hasError = true;
    }
    // check all fields for errors, then return.
    if (hasError) {
      return;
    }
    const value = {
      first_name,
      last_name,
      email,
      address_type,
      phone: strippedPhone ? strippedPhone : null,
      gender,
      gender_description,
      country: address_type === 'domestic' ? 'United States' : country,
      street: address,
      street_2: apartment || null,
      city,
      state: address_state,
      zipcode: zip,
    };
    if (address_type === 'domestic') {
      value.address_verified = !manual_address_entry;
    } else if (address_type === 'international') {
      value.international_address_verified = !manual_address_entry;
    }
    this.updateUser(value);
  }

  updateUser(user_data) {
    this.setState({isLoading: true});

    let data = JSON.stringify(user_data);

    rwbApi
      .putUser(data)
      .then((response) => {
        this.setState({isLoading: false});
        this.props.history.goBack();
      })
      .catch((error) => {
        alert(
          'There was a problem updating your personal info. Please try again later.',
        );
        this.setState({isLoading: false});
      });
  }

  selectAddressHandler = (response) => {
    console.log('selectAddressHandler', response);
    if (response) {
      const {city, state, zip, street, fullAddress} = response;
      // empty suite lists have empty strings as the first index
      if (response?.suiteList?.length > 1)
        this.setState({
          showApartmentModal: true,
          apartmentList: response.suiteList,
        });
      else this.setState({apartment: ''});
      this.setState({
        city,
        address_state: state,
        zip,
        address: street,
        fullAddressInternational: `${street}, ${city} ${state} ${zip}`,
        fullAddress: '',
        addressSuggestions: [],
      });
    }
  };

  onCountrySelect = (slug) => {
    this.setState(
      {
        showCountryModal: false,
        countrySlug: slug,
        country: COUNTRY_OPTIONS[slug].display,
      },
      () => {
        this.verifyAddress();
      },
    );
  };

  onApartmentSelect = (item) => {
    this.setState(
      {
        showApartmentModal: false,
        apartment: item,
      },
      () => {
        this.verifyAddress();
      },
    );
  };

  fetchOptions = (value) => {
    let {country, address_type} = this.state;
    const api = projectConfig.useMelissaPostalCode
      ? 'postalcode'
      : address_type === 'domestic'
      ? 'freeform'
      : 'globalfreeform';
    return melissaLookup(api, value, country);
  };

  updateOptionsSingular = (value) => {
    const thisFetchOptions = this.fetchOptions(value)
      .then((data) => {
        const options = data.map((option) => ({key: option}));
        this.setState({
          addressSuggestions: options,
        });
      })
      .catch((err) =>
        this.setState({error_string: 'Could not get the address.'}),
      );
  };

  updateOptions = debounce(this.updateOptionsSingular, DEBOUNCE_MS);

  render() {
    const {classes, history} = this.props;

    const {
      email,
      address_type,
      country,
      gender,
      address,
      apartment,
      showApartmentModal,
      address_state,
      city,
      zip,
      phone,
      fullAddress,
      isLoading,
      addressSuggestions,
      countrySlug,
      showCountryModal,
      gender_description,
      gender_description_error,
      email_error,
      address_error,
      city_error,
      state_error,
      phone_error,
      zip_error,
      gender_error,
      error_string,
    } = this.state;

    var manual_address_entry = this.state.manual_address_entry;
    var address_string = 'STREET';
    var apartment_string = 'APARTMENT';
    var state_string = 'STATE';
    var zip_string = 'ZIP';
    var city_string = 'CITY';
    if (this.state.address_type === 'international') {
      let fields = addressFieldDisplay(this.state.country);
      state_string = fields.state_string.toUpperCase();
      zip_string = fields.zip_string.toUpperCase();
      city_string = fields.city_string.toUpperCase();
      address_string = fields.address_string.toUpperCase();
    }
    const {showStreet, showApartment} = addressFieldsConfig();

    const hasSpecificStateOptions =
      projectConfig.profileLocationStateOptions.length > 0;

    return (
      <div className={styles.container}>
        <Loading size={100} color={'var(--white)'} loading={isLoading} />
        <Paper className={classes.root}>
          <Toolbar className={classes.toolbar}>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              onClick={() => history.goBack()}>
              <ChevronBackIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Personal Information
            </Typography>
            <IconButton
              edge="end"
              className={classes.menuButton}
              color="inherit"
              onClick={() => this.savePressed()}>
              <Typography variant="h6" className={classes.save}>
                Save
              </Typography>
            </IconButton>
          </Toolbar>
        </Paper>

        <div className={styles.displayNone}>
          <CountryModal
            title={'Country'}
            isOpen={showCountryModal}
            items={COUNTRY_OPTIONS}
            selectedValue={countrySlug}
            modalHandler={() =>
              this.setState((state) => ({
                showCountryModal: !state.showCountryModal,
              }))
            }
            onSelect={this.onCountrySelect}
          />
        </div>

        <div className={styles.displayNone}>
          <ScrollableListModal
            title={'Apartment Unit'}
            isOpen={showApartmentModal}
            items={this.state.apartmentList}
            selectedValue={this.state.apartment}
            modalHandler={() =>
              this.setState((state) => ({
                showApartmentModal: !state.showApartmentModal,
              }))
            }
            onSelect={this.onApartmentSelect}
          />
        </div>

        <div className={styles.contentContainer}>
          <div className={styles.formContainer}>
            <TextInput
              label={'Email'}
              type={'email'}
              error={email_error}
              value={email || ''}
              onValueChange={(text) => {
                this.setState({
                  email: text.target.value,
                  needsToSave: true,
                });
              }}
            />
            {this.includePersonalInfo && (
              <>
                {projectConfig.allowsOtherCountries && (
                  <RadioForm
                    className={styles.radioForm}
                    inline
                    radioProps={address_type_radio_props}
                    label={'Address Type'}
                    name={'address_type'}
                    error={address_error}
                    value={address_type}
                    onValueChange={(value) => {
                      this.setState(
                        {
                          manual_address_entry: false,
                          address_type: value,
                          needsToSave: true,
                        },
                        () => {
                          this.verifyAddress();
                        },
                      );
                    }}
                  />
                )}
                <div>
                  {!manual_address_entry ? (
                    <>
                      {address_type === 'international' && (
                        <div
                          className={styles.clickable}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({showCountryModal: true});
                          }}>
                          <TextInput
                            label={''}
                            value={country ? country : 'COUNTRY'}
                            onValueChange={(text) => {}}
                          />
                        </div>
                      )}
                      <TextInput
                        label={
                          projectConfig.useMelissaPostalCode
                            ? 'POSTAL CODE'
                            : 'ADDRESS'
                        }
                        value={
                          projectConfig.useMelissaPostalCode
                            ? zip || ''
                            : fullAddress
                        }
                        error={
                          projectConfig.useMelissaPostalCode
                            ? zip_error
                            : error_string
                        }
                        onValueChange={(text) => {
                          const {value} = text.target;
                          if (projectConfig.useMelissaPostalCode) {
                            this.setState({zip: value});
                          } else {
                            this.setState({fullAddress: value});
                          }
                          value.trim().length >
                            (projectConfig.useMelissaPostalCode ? 2 : 3) &&
                            this.updateOptions(value);
                        }}
                      />
                      {(projectConfig.useMelissaPostalCode
                        ? addressSuggestions.length > 0
                        : fullAddress.length > 0) && (
                        <AddressesList
                          addressSuggestions={addressSuggestions}
                          onSelect={this.selectAddressHandler}
                          // onCurrentLocationSelect={
                          //   this.selectCurrentLocationHandler
                          // }
                        />
                      )}
                      <p>
                        Type the first few characters of your address in the box
                        and then select from the list of matching addresses, or{' '}
                        <span
                          className={`link ${styles.clickable}`}
                          onClick={() =>
                            this.setState({manual_address_entry: true})
                          }>
                          manually enter your address.
                        </span>
                      </p>
                    </>
                  ) : (
                    <div>
                      {address_type === 'international' && (
                        <div
                          className={styles.clickable}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({showCountryModal: true});
                          }}>
                          <TextInput
                            label={''}
                            value={country ? country : 'COUNTRY'}
                            onValueChange={(text) => {}}
                          />
                        </div>
                      )}

                      {showStreet && (
                        <TextInput
                          label={'Address'}
                          value={address ? address : ''}
                          error={address_error}
                          onValueChange={(text) => {
                            this.setState({
                              address: text.target.value,
                              needsToSave: true,
                            });
                          }}
                        />
                      )}
                      {showApartment && (
                        <TextInput
                          label={apartment_string}
                          value={apartment ? apartment : ''}
                          error={null}
                          onValueChange={(text) => {
                            this.setState({
                              apartment: text.target.value,
                              needsToSave: false,
                            });
                          }}
                        />
                      )}
                      {!projectConfig.useMelissaPostalCode && (
                        <TextInput
                          label={city_string}
                          value={city ? city : ''}
                          error={city_error}
                          onValueChange={(text) => {
                            this.setState({
                              city: text.target.value,
                              needsToSave: true,
                            });
                          }}
                        />
                      )}
                      {!projectConfig.useMelissaPostalCode && (
                        <>
                          <ParentModal
                            title={state_string}
                            isOpen={this.state.stateDropdownVisible}
                            selectedValue={address_state}
                            modalHandler={() =>
                              this.setState({stateDropdownVisible: false})
                            }
                            placeholder={null}>
                            {projectConfig.profileLocationStateOptions.map(
                              (opt, index) => {
                                return (
                                  <div
                                    key={index}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                      this.setState({
                                        address_state: opt,
                                        stateDropdownVisible: false,
                                        needsToSave: true,
                                      });
                                    }}>
                                    <h2>{opt}</h2>
                                  </div>
                                );
                              },
                            )}
                          </ParentModal>
                          {/* State Manual Entry */}
                          {hasSpecificStateOptions ? (
                            <div
                              onClick={() =>
                                this.setState({stateDropdownVisible: true})
                              }>
                              <TextInput
                                label={state_string}
                                value={address_state ? address_state : ''}
                                error={state_error}
                                disabled={true}
                                onFocus={() => {
                                  this.setState({stateDropdownVisible: true});
                                }}
                              />
                            </div>
                          ) : (
                            <TextInput
                              label={state_string}
                              value={address_state ? address_state : ''}
                              error={state_error}
                              onValueChange={(text) => {
                                this.setState({
                                  address_state: text.target.value,
                                  needsToSave: true,
                                });
                              }}
                            />
                          )}
                        </>
                      )}
                      <TextInput
                        label={zip_string}
                        value={zip ? zip : ''}
                        error={zip_error}
                        onValueChange={(text) => {
                          this.setState({
                            zip: text.target.value,
                            needsToSave: true,
                          });
                        }}
                      />
                    </div>
                  )}
                  {showStreet && (
                    <div className={styles.autocompleteItems}>
                      <h3>{address_string}: </h3>
                      <p>{address}</p>
                    </div>
                  )}
                  {showApartment &&
                    (!isNullOrEmpty(apartment) || manual_address_entry) && (
                      <div className={styles.autocompleteItems}>
                        <h3>{apartment_string}: </h3>
                        <p>{apartment}</p>
                      </div>
                    )}
                  {!projectConfig.useMelissaPostalCode && (
                    <div className={styles.autocompleteItems}>
                      <h3>{city_string}: </h3>
                      <p>{city}</p>
                    </div>
                  )}
                  {!projectConfig.useMelissaPostalCode && (
                    <div className={styles.autocompleteItems}>
                      <h3>{state_string}: </h3>
                      <p>{address_state}</p>
                    </div>
                  )}
                  <div className={styles.autocompleteItems}>
                    <h3>{zip_string}: </h3>
                    <p>{zip}</p>
                  </div>
                </div>
                <br />
                {manual_address_entry && (
                  <span
                    className={`link ${styles.clickable}`}
                    onClick={() =>
                      this.setState({manual_address_entry: false})
                    }>
                    Use Auto Complete
                  </span>
                )}

                {projectConfig.phoneRequested && (
                  <TextInput
                    label={'Phone'}
                    type={'tel'}
                    value={phone || ''}
                    error={phone_error}
                    onValueChange={(text) => {
                      this.setState({
                        phone: text.target.value,
                        needsToSave: true,
                      });
                    }}
                  />
                )}
                {projectConfig.genderRequested && (
                  <RadioForm
                    radioProps={gender_radio_props}
                    inline
                    label={'Gender'}
                    name={'gender'}
                    error={gender_error}
                    value={gender}
                    onValueChange={(value) => {
                      this.setState({
                        gender: value,
                        needsToSave: true,
                      });
                    }}
                  />
                )}

                {this.state.gender === 'Custom' && (
                  <TextInput
                    label={'SELF DESCRIBE'}
                    value={gender_description}
                    error={gender_description_error}
                    onValueChange={(text) => {
                      this.setState({gender_description: text.target.value});
                    }}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(useStyles)(ProfilePersonalInfo));
